export type ScoreStatus = 'Minimal' | 'Moderate' | 'High'
export type StatusDotColor = 'red' | 'yellow' | 'green'

export const ScoreStatuses: ScoreStatus[] = ['Minimal', 'Moderate', 'High']

export function getStatusDotColorForStatus(
  status: ScoreStatus,
): StatusDotColor {
  switch (status) {
    case 'Minimal':
      return 'red'
    case 'Moderate':
      return 'yellow'
    case 'High':
      return 'green'
    default:
      return 'red'
  }
}
